/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Kind_SortingInputs */

const vi_stocktake_kind_sorting = /** @type {(inputs: Stocktake_Kind_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân loại`)
};

/**

* @param {Stocktake_Kind_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_kind_sorting = /** @type {((inputs?: Stocktake_Kind_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Kind_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_kind_sorting(inputs)
});